import React from 'react';

const CTA = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-primary/10 via-neutral-light to-accent/5 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_60%_60%,rgba(0,188,212,0.1)_0%,rgba(255,255,255,0)_50%)]"></div>
      
      <div className="container relative z-10">
        <div className="max-w-3xl mx-auto glass-card p-8 md:p-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to See <span className="text-primary">Your New Website?</span>
          </h2>
          <p className="text-lg mb-8">
            We've already built it. Book a 10-minute call to see your custom website prototype and discuss how it can start generating leads for your business.
          </p>
          
          <div className="max-w-3xl mx-auto">
            <div dangerouslySetInnerHTML={{ 
              __html: `<iframe src="https://api.snaplaunchstudio.com/widget/booking/a5aqjCaQnDgk9IcrHRis" style="width: 100%;height:900px;border:none;overflow: hidden;" scrolling="no" id="a5aqjCaQnDgk9IcrHRis_1749241597217"></iframe><br>`
            }} />
          </div>
          
          <div className="mt-8 text-sm text-secondary-light">
            <p>No obligation - we'll respond within 24 hours.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
